<template>
    <div class="layout-heading-tabs">
        <header class="layout-heading-tabs__header">
            <div class="layout-heading-tabs__container">
                <h1 class="typographies-heading-h1 layout-heading-tabs__title">
                    {{ title }}
                </h1>
                <slot name="tabs" />
            </div>
            <div class="layout-heading-tabs__actions">
                <slot name="actions" />
            </div>
        </header>
        <section class="layout-heading-tabs__content">
            <slot name="content" />
        </section>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.layout-heading-tabs {
    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 0 var(--spacing-4);
    }

    &__title {
        margin: 0 var(--spacing-4) 0 0;
    }

    &__container {
        display: flex;
        align-items: center;
    }

    &__actions {
        display: flex;
        gap: var(--spacing-2);
    }

    &__content {
        min-width: 0;
        display: flex;
        flex-direction: column;
    }
}
</style>
